import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Solution() {
  return <section className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-170" data-mp="1ejauekalyg7w">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-171" data-mp="10tph9qjhov7s">
        <p className="mb-5 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-sunshine" data-id="element-172" data-mp="10rd2fm9130yy">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="qv9olj4tddw6" />
          Il existe une meilleure solution
        </p>
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl md:text-5xl" data-id="element-174" data-mp="vucuf5smbo57">
          Et s’ils vous suppliaient de{' '}
          <span className="italic text-sunshine" data-id="element-175" data-mp="hw68mo0y1elw">construire</span> — plutôt que de réclamer
          plus de temps d’écran ?
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-176" data-mp="2c8malcmpi6ky">
          MakerLab offre à vos enfants plus de 100 projets de robots concrets
          qu’ils auront vraiment envie de réaliser — avec des matériaux simples du quotidien
          et des PDF faciles à suivre, étape par étape.
        </p>
        <div className="mt-10" data-id="element-177" data-mp="2y3vzkjcazgb">
          <CtaButton data-id="element-178" data-mp="2ywuxzc24knw">Obtenir MakerLab aujourd’hui</CtaButton>
        </div>
      </div>
    </section>;
}